import qs from 'query-string';
import { useCallback, useMemo } from 'react';
/**
 *
 * @depricated Do not use this hook, use the Navigation hook from the IA Navigation Helper
 */
export function useQueryParams(search, parseOptions) {
    const params = useMemo(() => qs.parse(search, parseOptions), [search, parseOptions]);
    const getQueryStringUrl = useCallback((url, query = {}, opts) => {
        return qs.stringifyUrl({ url, query }, opts);
    }, []);
    return {
        params,
        getQueryStringUrl,
    };
}
